import * as React from 'react';

function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }

  return target;
}

var IconShoppingBag_4 = function IconShoppingBag_4(props) {
  return /*#__PURE__*/React.createElement("svg", _object_spread({
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1932 11.9478C10.3196 11.8588 10.4704 11.811 10.625 11.811H26.375C26.464 11.811 26.5524 11.8269 26.6358 11.8579L26.375 12.561C26.6358 11.8579 26.6367 11.8582 26.6375 11.8585L26.6393 11.8591L26.643 11.8605L26.6511 11.8637L26.6703 11.8714C26.6843 11.8773 26.7008 11.8844 26.7196 11.8931C26.7571 11.9105 26.8038 11.934 26.8583 11.9649C26.9672 12.0268 27.1064 12.1182 27.2645 12.2496C27.5821 12.5135 27.9676 12.9317 28.3388 13.5817C29.0793 14.8783 29.75 17.0732 29.75 20.7806C29.75 23.1227 29.054 25.284 28.375 26.841C28.0337 27.6234 27.6922 28.2633 27.4348 28.7096C27.306 28.9329 27.1979 29.1084 27.1208 29.2296C27.0823 29.2903 27.0515 29.3374 27.0298 29.3702L27.0041 29.4086L26.9967 29.4196L26.9944 29.423L26.9936 29.4242L26.9932 29.4247C26.9931 29.4249 26.993 29.4251 26.375 29.0001L26.993 29.4251C26.8531 29.6285 26.6219 29.7501 26.375 29.7501H10.625C10.4704 29.7501 10.3196 29.7023 10.1932 29.6133L10.625 29.0001C10.1932 29.6133 10.1927 29.6129 10.1921 29.6126L10.1911 29.6118L10.1888 29.6102L10.1835 29.6064L10.17 29.5965C10.1598 29.5889 10.1472 29.5793 10.1324 29.5677C10.1026 29.5443 10.0639 29.5126 10.0175 29.4719C9.92466 29.3904 9.80123 29.2729 9.6579 29.114C9.37087 28.7958 9.00594 28.3136 8.64748 27.6262C7.92888 26.2481 7.25 24.0718 7.25 20.7806C7.25 17.4893 7.92888 15.3131 8.64748 13.935C9.00594 13.2475 9.37087 12.7654 9.6579 12.4471C9.80123 12.2882 9.92466 12.1707 10.0175 12.0892C10.0639 12.0485 10.1026 12.0168 10.1324 11.9935C10.1472 11.9818 10.1598 11.9722 10.17 11.9646L10.1835 11.9548L10.1888 11.9509L10.1911 11.9493L10.1921 11.9485C10.1927 11.9482 10.1932 11.9478 10.625 12.561L10.1932 11.9478ZM10.9059 13.311C10.867 13.3495 10.8219 13.3962 10.7718 13.4517C10.5666 13.6792 10.2753 14.0574 9.97752 14.6285C9.38362 15.7675 8.75 17.701 8.75 20.7806C8.75 23.8602 9.38362 25.7937 9.97752 26.9326C10.2753 27.5037 10.5666 27.8819 10.7718 28.1094C10.8219 28.165 10.867 28.2117 10.9059 28.2501H25.9637C26.0138 28.1678 26.0716 28.0708 26.1355 27.9601C26.3703 27.5531 26.6851 26.9635 27 26.2413C27.6335 24.7889 28.25 22.8406 28.25 20.7806C28.25 17.2421 27.6082 15.3272 27.0362 14.3255C26.7511 13.8263 26.4804 13.5483 26.3058 13.4032C26.2583 13.3638 26.2173 13.3336 26.1841 13.311H10.9059Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4533 9.95559C14.4369 10.0094 14.4357 10.0349 14.4356 10.0349C14.4355 10.0349 14.4355 10.0347 14.4355 10.0345V15.1832C14.4355 15.5974 14.0998 15.9332 13.6855 15.9332C13.2713 15.9332 12.9355 15.5974 12.9355 15.1832V10.0342C12.9355 9.68654 13.0632 9.33693 13.2145 9.04713C13.3736 8.74238 13.5955 8.43374 13.8614 8.15637C14.3776 7.61793 15.1617 7.09668 16.0918 7.09668H20.9043C21.8344 7.09668 22.6185 7.61793 23.1347 8.15637C23.4006 8.43374 23.6225 8.74238 23.7816 9.04713C23.9329 9.33693 24.0605 9.68654 24.0605 10.0342V15.2842C24.0605 15.6984 23.7248 16.0342 23.3105 16.0342C22.8963 16.0342 22.5605 15.6984 22.5605 15.2842V10.0345C22.5605 10.0347 22.5605 10.0349 22.5605 10.0349C22.5604 10.0349 22.5592 10.0094 22.5428 9.95559C22.5256 9.89926 22.4965 9.82663 22.4519 9.74133C22.3623 9.56967 22.2256 9.37561 22.0519 9.19444C21.6889 8.81581 21.2699 8.59668 20.9043 8.59668H16.0918C15.7262 8.59668 15.3072 8.81581 14.9442 9.19444C14.7705 9.37561 14.6338 9.56967 14.5442 9.74133C14.4996 9.82663 14.4705 9.89926 14.4533 9.95559Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 28.75C37.5 33.0302 34.0302 36.5 29.75 36.5C25.4698 36.5 22 33.0302 22 28.75C22 24.4698 25.4698 21 29.75 21C34.0302 21 37.5 24.4698 37.5 28.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4877 32.375H32.0521V30.96H32.9887V29.8042H32.0521V25.2505H30.0692L26.9902 30.3721V30.96H30.4877V32.375ZM28.6044 29.8042L30.5176 26.4661V29.8042H28.6044Z",
    fill: "white"
  }));
};

export { IconShoppingBag_4 };